import {Component, inject, input} from '@angular/core';
import {MatError, MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {FormArray, FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {PollTypeEnum} from "../../../../../../utils/enums/poll-type.enum";
import {IAvailableTime, IAvailableTimeForm} from "../../../../../../utils/interfaces/unit";
import {AlertService} from "../../../../../../shared/services/alert.service";
import {UnitEditFormService} from "../../services/unit-edit-form.service";

@Component({
  selector: 'app-unit-available-time-section',
  standalone: true,
  imports: [
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    ReactiveFormsModule
  ],
  templateUrl: './unit-available-time-section.component.html',
  styleUrl: './unit-available-time-section.component.scss'
})
export class UnitAvailableTimeSectionComponent {
  typePoll = input.required<PollTypeEnum>();
  form = input.required<FormArray<FormGroup<IAvailableTimeForm>>>();

  formNewItem!: FormGroup<IAvailableTimeForm>;

  private readonly alertService = inject(AlertService);
  private readonly unitEditFormService = inject(UnitEditFormService);


  constructor() {
    this.formNewItem = new FormGroup<IAvailableTimeForm>({
      description: new FormControl<string | null>(null, Validators.required),
      startTime: new FormControl<string | null>(null, Validators.required),
      endTime: new FormControl<string | null>(null, Validators.required),
      typePoll: new FormControl<PollTypeEnum | null>(null, Validators.required),
    });
  }


  get sectionLabel(): string {
    return this.typePoll() === PollTypeEnum.Satisfaction
      ? 'Turno: Horário que estará disponível a pesquisa de satisfação'
      : 'Turno: Horário que estará disponível a pesquisa de reserva de pratos';
  }

  itemAdd(): void {
    this.formNewItem.controls.typePoll.setValue(this.typePoll())
    if (this.formNewItem.invalid) {
      this.formNewItem.markAllAsTouched();
      return;
    }
    const newAvailableTime = this.formNewItem
      .value as IAvailableTime;

    if (
      this.form()
        .getRawValue()
        .map((value) => value.description!.toLocaleLowerCase())
        .includes(newAvailableTime.description.toLocaleLowerCase())
    ) {
      this.alertService.danger(
        'Já existe um horário disponível com essa descrição.'
      );

      return;
    }

    this.form().push(
      this.unitEditFormService.availableTimeCreate(newAvailableTime)
    );
    this.formNewItem.reset();
  }

  itemDelete(index: number): void {
    this.form().removeAt(index);
  }
}
